module.exports = __webpack_public_path__ + "6ff5ee967a6b3c8512d2ed11032b26f4.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/new-design/icons/mastercard.svg
// module id = 1275
// module chunks = 73